<template>
  <v-container fluid class="user-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">User Information</v-stepper-step>

              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">User Details</v-stepper-step>

            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Create New User</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user.username"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="User Name"
                          persistent-hint
                          single-line hint="Enter the user name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.userid"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="User Id"
                          persistent-hint
                          single-line hint="Enter the user id">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.useremail"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Email Address"
                          persistent-hint
                          single-line hint="Enter the user email address">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.usermobile"
                          outlined
                          dense
                          placeholder="Mobile Number"
                          persistent-hint
                          single-line hint="Enter the mobile number">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                          v-model="user.locationid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select> 
                        <v-select
                          class="mb-4"
                          :items="saleschannels.map(x => {
                            return {text: x.channelname, value: x._id};
                          })"
                          v-model="user.channelid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select> 
                        <v-select
                          class="mb-4"
                          :items=usertypes
                          v-model="user.usertype"
                          v-bind:error="errorindex == 6"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the user type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="roles.map(x => {
                            return {text: x.rolecode, value: x._id};
                            })"
                          v-model="user.roleid"
                          v-bind:error="errorindex == 7"
                          outlined
                          dense
                          placeholder="Role"
                          persistent-hint
                          single-line hint="Please choose the role">
                        </v-select> 
                        <v-select
                          class="mb-4"
                          :items="menus.map(x => {
                            return {text: x.menucode, value: x._id};
                            })"
                          v-model="user.menuid"
                          v-bind:error="errorindex == 8"
                          outlined
                          dense
                          placeholder="Menu"
                          persistent-hint
                          single-line hint="Please choose the menu">
                        </v-select> 
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user.userpassword"
                          v-bind:error="errorindex == 9"
                          outlined
                          dense
                          placeholder="Password"
                          persistent-hint
                          single-line hint="Enter user password. Min 6 characters long">
                        </v-text-field>
                        <v-switch
                          v-model="user.userstatus"
                          color="primary"
                          v-bind:label="user.userstatus"
                          value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createUser()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      user: {
        userid: '',
        username: '',
        useremail: '',
        userpassword: '',
        usertype: '',
        userstatus: 'Active',
        userimage: undefined,
        imagename: ''
      },
      usertypes: ['System Administrator', 'Company Administrator', 'Sales Representative', 'Sales Driver', 'Graphic Designer', 'Content Creator'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  async created () {
    if(this.roles.length==0) await this.getRolesRequest();
    if(this.menus.length==0) await this.getMenusRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
  },
  methods: {
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Menu', ['getMenusRequest']),
    ...mapActions('Role', ['getRolesRequest']),
    ...mapActions('User', ['createUserRequest','getUsersRequest']),
    checkError(){
      if(!this.user.username){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.user.userid){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.user.useremail){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.user.locationid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.user.channelid){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.user.usertype){
        this.haserrors = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.user.roleid){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.user.menuid){
        this.haserrors = true;
        this.errorindex = 8;
        return false;
      }
      if(!this.user.userpassword || this.user.userpassword.length<6){
        this.haserrors = true;
        this.errorindex = 9;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createUser() {
      this.createUserRequest(this.user)
      this.getUsersRequest()
      router.push('/user/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.user.userimage = file;
      this.user.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('User', ['isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('Menu', ['menus']),
    ...mapState('Role', ['roles'])
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
